import { CaretDown } from "@phosphor-icons/react";
import classNames from "classnames";
import * as React from "react";
import styles from "./Navbar.module.css";

export interface MobileNavItemProps {
  name: string;
  hasDropdown: boolean;
  href?: string;
  isExpanded: boolean;
  onToggle: () => void;
  children?: React.ReactNode;
}

export const MobileNavItem: React.FC<MobileNavItemProps> = ({
  name,
  hasDropdown,
  href,
  isExpanded,
  onToggle,
  children,
}) => {
  const contentRef = React.useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = React.useState<number>(0);

  // Measure content height for smooth expansion
  React.useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isExpanded, children]);

  if (!hasDropdown) {
    return (
      <a href={href} className={styles.mobileNavItem}>
        <span className={styles.mobileNavItemLabel}>{name}</span>
      </a>
    );
  }

  return (
    <div className={styles.mobileNavItemWrapper}>
      <button
        className={classNames(
          styles.mobileNavItem,
          isExpanded && styles.mobileNavItemExpanded,
        )}
        onClick={onToggle}
        aria-expanded={isExpanded}
        type="button"
      >
        <span className={styles.mobileNavItemLabel}>{name}</span>
        <CaretDown
          className={classNames(
            styles.mobileNavItemChevron,
            isExpanded && styles.mobileNavItemChevronExpanded,
          )}
          size={18}
        />
      </button>

      <div
        className={classNames(
          styles.mobileNavItemContent,
          isExpanded && styles.mobileNavItemContentExpanded,
        )}
        style={{
          height: isExpanded ? `${contentHeight}px` : "0px",
        }}
      >
        <div ref={contentRef} className={styles.mobileNavItemContentInner}>
          {children}
        </div>
      </div>
    </div>
  );
};
